export default "__VITE_ASSET__ew7_CiGP__"